// CORE
import { useEffect, useState } from "react";

// THIRD-PARTY LIBRARIES
import { DragDropContext } from "react-beautiful-dnd";
import { Col, Row } from "react-bootstrap";

// COMPONENTS
import Controls, { controls } from "./Controls";
import FormData from "./Form";
import FormWrapper from "components/Form/form-wrapper";

function FormBuilder({ formObject, setFormObject }) {
    const [formData, setFormData] = useState(formObject || []);
    console.log("Form Data >>> ", formData);
    console.log("Form Object >>> ", formObject);

    useEffect(() => {
        setFormObject(formData);
    }, [formData, setFormObject]);

    const onDragEnd = (data) => {
        const { draggableId, source, destination } = data;
        if (source && destination) {
            if (source.droppableId === "controls_droppable") {
                // console.log("controls_droppable-----------------");
                const control = controls?.find((e) => e?.type === draggableId),
                    newFormControl = {
                        id: `${formData.length}`,
                        ...control,
                    };
                const newFormData = [...formData];
                newFormData.splice(destination.index, 0, newFormControl);
                setFormData(newFormData);
            }
            if (source.droppableId === "form_droppable") {
                if (source.index !== destination.index) {
                    // console.log("form_droppable-----------------");

                    const newFormData = [...formData];
                    const movedFormControl = newFormData.splice(
                        source.index,
                        1
                    )[0];
                    newFormData.splice(destination.index, 0, movedFormControl);
                    setFormData(newFormData);
                }
            }
        }
    };

    return (
        <DragDropContext onDragEnd={onDragEnd}>
            <Row>
                <Col xs="12" md="6">
                    <Controls />
                </Col>
                <Col xs="12" md="6">
                    <FormWrapper>
                        <FormData
                            formData={formData}
                            updateFormData={(e) => {
                                setFormObject(e);
                            }}
                        />
                    </FormWrapper>
                </Col>
            </Row>
        </DragDropContext>
    );
}

export default FormBuilder;
